import React from "react";
import { string } from "prop-types";

const NagorikLogo = ({ width = "336", height = "100", color = "#34b8b5" }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 336 47"
    width={width}
    height={height}
  >
    <g id="Layer_1">
      <g>
        <path
          fill={color}
          d="M155.833,12.796h-3.793h-7.746h-7.155h-3.146H90.979c-0.159-0.182-0.259-0.342-0.271-0.486
			c-0.036-0.449-0.053-0.814-0.053-1.095c0-0.282,0.136-0.61,0.409-0.989c0.272-0.378,0.704-0.759,1.293-1.147
			c0.589-0.387,1.358-0.765,2.307-1.134c0.95-0.37,2.102-0.695,3.456-0.977c1.232-0.245,2.612-0.399,4.142-0.46
			c1.529-0.062,3.147,0.039,4.854,0.303c1.704,0.264,3.468,0.721,5.287,1.371c1.819,0.65,3.627,1.548,5.421,2.69V9.026
			c-1.372-1.461-2.916-2.729-4.629-3.812c-1.715-1.082-3.496-1.951-5.342-2.612c-1.846-0.659-3.718-1.106-5.618-1.344
			c-1.899-0.237-3.728-0.25-5.486-0.039c-1.829,0.229-3.543,0.559-5.143,0.989s-2.994,0.971-4.181,1.623
			c-1.187,0.65-2.123,1.406-2.808,2.268c-0.687,0.861-1.029,1.846-1.029,2.955v0.606c0,0.405,0.118,0.757,0.356,1.055
			c0.237,0.298,0.528,0.572,0.871,0.818c0.342,0.247,0.707,0.484,1.094,0.712c0.377,0.222,0.72,0.455,1.031,0.694
			c-1.839-0.036-4.581-0.027-6.172,0.278c-3.306,0.634-4.228,1.293-4.666,1.555v5.71c-2.056-1.372-4.024-2.376-5.904-3.019
			c-1.88-0.641-3.654-1.024-5.323-1.147c-1.67-0.122-3.234-0.029-4.693,0.276c-1.457,0.31-2.784,0.726-3.979,1.253
			c-2.829,1.23-5.36,3.083-7.591,5.561v3.557c2.354-0.018,4.568-0.035,6.641-0.051h3.019c0.799,0,1.585-0.003,2.358-0.014
			c0.773-0.008,1.499-0.012,2.175-0.012h1.673c0.44,0,0.77,0.027,0.989,0.078c0.219,0.054,0.359,0.13,0.421,0.225
			c0.061,0.097,0.061,0.202,0,0.316c-0.063,0.115-0.154,0.223-0.276,0.33c-0.316,0.297-0.818,0.624-1.503,0.976l-6.693,2.423v6.141
			l8.328-3.162c2.02-0.844,3.565-1.577,4.638-2.201c1.072-0.625,1.608-1.243,1.608-1.858v-3.584c0-0.351-0.256-0.663-0.766-0.937
			c-0.51-0.272-1.124-0.508-1.844-0.711c-0.721-0.201-1.468-0.361-2.241-0.474c-0.772-0.115-1.432-0.181-1.977-0.198
			c-0.544-0.037-1.137-0.057-1.778-0.067c-0.643-0.009-1.244-0.013-1.806-0.013h-1.923c-0.193,0.019-0.369,0.019-0.527,0
			c-0.141-0.016-0.267-0.051-0.382-0.104c-0.114-0.053-0.18-0.133-0.197-0.238c-0.018-0.124-0.013-0.245,0.012-0.369
			c0.027-0.124,0.136-0.247,0.33-0.369c0.14-0.105,0.576-0.269,1.304-0.488c0.73-0.22,1.621-0.438,2.676-0.658
			c1.054-0.219,2.204-0.399,3.453-0.541c1.247-0.14,2.475-0.179,3.688-0.119c1.213,0.062,2.333,0.255,3.361,0.58
			c1.028,0.326,1.842,0.857,2.439,1.595h-0.027l-0.026,20.408h7.774V17.881c0.229-0.65,0.607-1.067,1.134-1.252
			c0.52-0.181,3.202-0.663,4.685,0.295c0.159,0.121,0.317,0.245,0.471,0.395c0.387,0.378,0.716,0.849,0.989,1.412
			c0.273,0.563,0.409,1.214,0.409,1.951v22.672h7.597V21.489c0-2.646-2.221-4.505-4.414-5.737h26.324
			c0.04,0.002,0.078,0.01,0.119,0.01c1.259-0.001,1.94,0.448,2.285,1.285c-1.985,0.393-10.445,2.428-20.575,10.149l0.286,7.858
			c0,0,6.181-1.542,12.632,0.278c4.458,1.26,7.039,4.099,7.917,5.22c0.001,1.72,0.002,2.817,0.002,2.817l7.479-0.011
			c0,0-0.093-20.433-0.019-23.437c0.033-1.323-0.722-2.862-1.971-4.17h5.112v0.021h10.301h7.746h0.723
			c0.154,0.031,0.314,0.053,0.488,0.053c0.633,0,1.132,0.111,1.501,0.33c0.37,0.22,0.642,0.54,0.818,0.962
			c-0.493,0.051-1.362,0.211-2.608,0.473c-1.247,0.264-2.784,0.752-4.61,1.464c-1.827,0.71-3.895,1.702-6.205,2.976
			c-2.308,1.273-4.781,2.955-7.415,5.045l0.289,8.298c1.23-0.28,2.548-0.465,3.952-0.553c1.195-0.088,2.555-0.088,4.084,0
			c1.528,0.088,3.117,0.368,4.768,0.843c1.124,0.316,2.13,0.716,3.016,1.199c0.886,0.484,1.664,0.979,2.332,1.487
			c0.666,0.51,1.219,0.997,1.658,1.463c0.439,0.465,0.773,0.839,1.001,1.12v1.738v0.633h7.56c-0.018-3.021-0.026-5.911-0.026-8.667
			c0-1.159-0.006-2.354-0.013-3.582c-0.009-1.231-0.013-2.421-0.013-3.569v-3.229c0-1.001,0.008-1.852,0.027-2.555
			c1.897-0.315,3.481-0.496,4.754-0.541c1.274-0.044,2.094-0.02,2.463,0.067c0.561,0.14,1.042,0.306,1.436,0.5
			c0.396,0.193,0.742,0.36,1.04,0.501c0.667,0.317,1.186,0.667,1.554,1.054c0.369,0.387,0.553,0.799,0.553,1.237
			c0,0.44-0.208,0.906-0.62,1.397c-0.411,0.493-1.083,0.994-2.014,1.502c-0.615,0.351-1.335,0.685-2.16,1
			c-0.914,0.37-1.564,0.505-1.949,0.409c-0.387-0.096-0.615-0.294-0.685-0.593c-0.072-0.297-0.031-0.64,0.118-1.026
			c0.148-0.387,0.303-0.694,0.46-0.923c-0.315,0.072-0.628,0.145-0.935,0.225c-0.307,0.079-0.61,0.153-0.908,0.223
			c-0.3,0.088-0.598,0.177-0.896,0.264c-0.229,0.439-0.418,0.926-0.567,1.462c-0.149,0.536-0.225,1.049-0.225,1.542v0.54
			c0,0.165,0.004,0.35,0.013,0.552c0.009,0.203,0.013,0.435,0.013,0.7v0.973c0,0.493,0.162,0.983,0.487,1.475
			c0.325,0.492,0.787,0.896,1.384,1.211c0.597,0.317,1.325,0.51,2.187,0.58c0.859,0.07,1.816-0.053,2.87-0.369
			c0.843-0.246,1.691-0.54,2.543-0.883c0.852-0.342,1.796-0.785,2.833-1.331c0.386-0.21,0.732-0.46,1.039-0.749
			c0.306-0.29,0.567-0.607,0.777-0.95c0.211-0.342,0.373-0.683,0.488-1.027c0.114-0.342,0.171-0.672,0.171-0.988v-3.187
			c0-0.368-0.132-0.818-0.396-1.343c-0.264-0.528-0.61-1.058-1.04-1.594c-0.43-0.536-0.918-1.058-1.462-1.569
			c-0.545-0.508-1.089-0.93-1.634-1.263c-0.579-0.352-1.062-0.637-1.448-0.857c-0.387-0.218-0.76-0.411-1.12-0.579
			c-0.36-0.167-0.733-0.332-1.119-0.5c-0.388-0.167-0.862-0.366-1.423-0.593c-0.615-0.264-1.261-0.478-1.937-0.645
			c-0.676-0.168-1.348-0.304-2.015-0.409c-0.667-0.105-1.322-0.18-1.962-0.225c-0.642-0.044-1.234-0.065-1.778-0.065
			c-0.266-0.394-0.592-0.768-0.945-1.133h4.818h13.83v-2.977h-13.83H155.833z M110.829,30.143c0,0,3.763-4.399,12.577-7.354
			c-0.012,3.286-0.015,8.248-0.016,12.483C118.196,30.832,110.829,30.143,110.829,30.143z M155.833,26.377v3.016v3.121v3.043
			c-0.649-0.562-1.321-1.063-2.015-1.503c-0.694-0.438-1.37-0.824-2.028-1.159c-0.658-0.333-1.286-0.617-1.883-0.855
			c-0.598-0.237-1.309-0.459-2.133-0.672c-1.406-0.405-2.784-0.685-4.136-0.844c0.72-0.79,1.649-1.58,2.792-2.372
			c0.983-0.685,2.243-1.426,3.781-2.225c1.537-0.799,3.411-1.55,5.624-2.253V26.377z"
        />
        <path
          fill={color}
          d="M109.142,37.454c-1.617,3.117,0.081,6.525,0.081,6.525h5.353c0,0-0.039-1.114,0.599-2.419
			c0.388-0.793,1.323-1.163,2.138-0.819l1.018-1.623C118.33,39.118,114.056,36.693,109.142,37.454z"
        />
        <path
          fill={color}
          d="M39.279,14.115L2.278,14.126v2.983l20.688,0.014c1.163,0,2.167,1.286,2.486,2.564
			c0.31,1.24,0.202,7.188,0.202,8.662c-1.689-2.802-3.177-5.283-6.339-6.407c-4.536-1.613-6.814-0.949-11.288,0.565
			c-3.008,1.018-7.463,2.648-6.994,6.429v7.412c0.038,1.561,1.011,2.725,2.386,3.31c3.724,1.588,11.018-1.695,14.427-3.39
			c4.693-2.332,1.027-6.136-1.446-8.271L11.87,29.49c0.488,0.506,1.078,0.934,0.972,1.323c-0.4,1.471-3.705,2.009-5.538,2.497
			c-0.897,0.239-1.672,0.133-1.852-0.644c-0.8-3.456,10.397-8.242,14.8-5.311c2.276,1.515,4.374,4.44,5.074,6.987
			c0.568,2.07,0.327,8.005,0.327,10.519h7.661V21.495c0-1.978-0.97-3.651-2.689-4.372l5.086-0.001
			c2.846,1.273,2.575,4.246,2.575,4.246v23.493h7.444V21.345C45.732,18.429,44.279,14.115,39.279,14.115z"
        />
        <path
          fill={color}
          d="M237.121,24.949c0.032,1.36,0.854,2.373,2.014,2.883c3.143,1.384,9.301-1.477,12.178-2.953
			c3.961-2.032-1.521-10.223-3.609-12.084l-4.68,0.096c-2.54,0.887-6.3,2.306-5.904,5.601V24.949z M244.603,19.451
			c0.419,0.402,1.92,2.422,1.571,3.292c-0.329,0.819-2.929,1.798-4.438,1.759c-0.806-0.02-0.998-0.812-1.04-1.003
			C240.416,22.254,242.312,20.332,244.603,19.451z"
        />
        <path
          fill={color}
          d="M315.142,12.82h-23.156c-0.148-0.008-0.29-0.024-0.445-0.024l-38.717,0.011v0.014l-0.106,3.132h22.186
			c1.007,0.084,1.594,0.508,1.9,1.249c-1.977,0.391-10.405,2.419-20.495,10.11l0.285,7.827c0,0,6.157-1.536,12.583,0.277
			c4.441,1.255,7.011,4.083,7.887,5.2c0.001,1.713,0.002,2.806,0.002,2.806l7.45-0.011c0,0-0.092-20.353-0.019-23.345
			c0.032-1.304-0.703-2.819-1.924-4.113h5.727c2.496,1.339,2.255,4.069,2.255,4.069v23.401h7.415V19.997
			c0-1.243-0.268-2.739-0.962-4.045h9.878c0.186,0.037,0.386,0.06,0.616,0.048c-2.623,0.323-4.877,3.918-4.877,6.141V31.3
			c0,2.61,0.896,2.73,3.724,3.832c0.898,0.348,3.172,1.378,3.96,1.089c1.631-0.599,2.193-5.925,16.748-10.624
			c0.398-0.129,0.929,0.404,0.586,0.75c-2.178,2.237-3.782,4.345-4.814,6.336c-1.95,3.764-2.171,6.639-1.45,8.68
			c0.751,2.13,7.302,4.238,8.97,4.568l1.804-2.05c-1.169-0.077-2.877-1.176-2.988-2.32c-0.423-4.401,2.012-8.43,4.605-11.794
			c0.615-0.8,1.77-2.202,0.702-3.081l-8.434-6.172c-0.737-0.398-1.603-0.645-2.599-0.727c-4.282-0.378-10.422,3.732-13.213,6.759
			c0-0.95,0-1.851,0.013-2.731c0.018-1.446-0.256-7.612,1.957-7.859c0.952,0,1.9-0.004,2.851-0.004H335v-0.03V12.82v-0.024
			L315.142,12.82z M277.062,35.356c-5.174-4.422-12.512-5.109-12.512-5.109s3.749-4.382,12.528-7.325
			C277.065,26.195,277.062,31.138,277.062,35.356z"
        />
        <path
          fill={color}
          d="M233.46,12.796h-0.501h-38.787l-0.005,0.024v3.132h9.944c-1.015,0.227-2.561,0.67-3.689,1.433
			c-2.137,1.432-1.695,3.768-1.695,3.768s8.61,4.316,9.873,4.947c1.263,0.642,1.116,2.021-1.326,3.326
			c-0.453,0.221-4.768,2.526-5.316,2.821c-3.8,2.105-2.968-1.347-2.305-2.368c-0.716-0.032-2.642-0.095-2.642-0.095
			c-0.895,1.379-1.263,3.021-1.263,4.095c0,0.832,0.558,2.484,1.789,3.674c1.926,1.842,5.968,3.642,7.768,2.842
			c1.8-0.811,4.979-2.779,7.337-4.053l0.558-0.295c6.663-0.347,11.526,3.684,11.526,3.684v3.737h7.789V19.722
			c0-0.654-0.105-2.268-0.968-3.77h3.342V12.82h-1.43V12.796z M217.99,30.827c0,0,0.61-0.389,1.547-0.979
			c0.937-0.589,1.558-4.274-2.768-6.147c-0.568-0.253-5.305-2.4-9.052-3.937c-0.611-0.242-0.926-1.368,0.2-1.768
			c0.846-0.309,4.946-1.491,6.872-2.044h7.664c1.035,0.377,2.253,1.259,2.253,3.338l0.021,15.105
			C224.727,34.395,224.011,32.606,217.99,30.827z"
        />
        <path
          fill={color}
          d="M241.97,29.125c-0.691-0.016-1.407,0.022-1.98,0.342c-0.542,0.303-0.896,0.824-1.234,1.329
			c-0.53,0.792-1.059,1.584-1.589,2.376c-0.158,0.237-0.321,0.485-0.349,0.774c-0.027,0.28,0.075,0.567,0.181,0.841
			c0.425,1.1,2.028,3.878,2.028,3.878s5.974-2.378,9.486-0.787c3.134,1.419,4.046,4.39,4.633,5.424h3.016
			c0.017-1.79-0.274-5.015-2.23-7.975C251.392,31.482,246.517,29.232,241.97,29.125z"
        />
      </g>
    </g>
    <g id="Layer_2"></g>
  </svg>
);

NagorikLogo.propTypes = {
  width: string,
  height: string,
  color: string
};

export default NagorikLogo;
